import React from "react";
import styles from "./styles.scss";

const PlayerInjuryStatusItem = ({ injuryStatus }: { injuryStatus: any }) => {
  return injuryStatus && injuryStatus !== "" ? (
    <div className="rotoql-player-injury-status">
      {injuryStatus}
      <style jsx global>
        {styles}
      </style>
    </div>
  ) : null;
};

export default PlayerInjuryStatusItem;
